<template>
    <Popup class="create-product-popup" title="Create new product" @close="closePopup()">
        <template v-slot:content>
            <label class="form_steps_label step_1" :class="{'active': step == 2}">
                <span class="icon"></span> Select a product type
              <span v-if="step == 2 && newData['is_subscription']" style="font-size: 13px;color: #4268df;margin-left: 10px;">
                Subscription
              </span>
              <span v-else-if="step == 2" style="font-size: 13px;color: #4268df;margin-left: 10px;">
                One-time
              </span>
            </label>
            <div class="funnel_type_radio_wrpr" :class="{'active': step == 1}">
              <div class="row">
                <div class="col margin-rl-20" style="">
                  <SelectButton :src="require('@/assets/img/tg-icon-1.svg')" :value="false" v-model="newData.is_subscription"
                                label="One-time"></SelectButton>
                </div>
                <div class="col margin-rl-20">
                  <SelectButton :src="require('@/assets/img/tg-icon-3.svg')" :value="true" v-model="newData.is_subscription"
                                label="Subscription"></SelectButton>
                </div>
              </div>
            </div>
            <div class="funnel_details_step" :class="{'active': step == 2}">
                <label class="form_steps_label step_2" :class="{'active': newData['name']}">
                    <span class="icon"></span> Your product details
                </label>

              <InputField class="product-name" label="Product name" v-model="newData['name']" :error="!newData['name']?'Invalid product name':null">

              </InputField>

              <div v-if="!newData.is_subscription">
                <PriceField label="Price" v-model.number="newData.price"
                            :required="!newData.is_subscription" :currency-code="currencySymbol"
                            :error="!newData['price']?'Invalid price':null"></PriceField>
              </div>
              <div v-else>
                <div class="form_group_col_4" style="display: flex;flex-direction: row;">

                  <div class="form-group mb-15 with-icon with_top_block">
                    <PriceField label="Billing amount" :currency-code="currencySymbol"
                                v-model.number="newData.billing_amount"
                                :required="newData.is_subscription"/>
                  </div>
                  <div class="form-group mb-15 with_top_block">
                    <span class="form_group_top_block">Recurring times</span>
                      <v-select
                          :options="recurringTimes.selectOptions"
                          label="label"
                          :searchable="false"
                          :clearable="false"
                          :reduce="action => action.id"
                          v-model="newData.billing_recurring_times"
                          append-to-body />
                  </div>
                  <div class="form-group mb-15 with_top_block">
                    <span class="form_group_top_block" >Billing cycle</span>
                    <v-select
                        :options="billingCycle.selectOptions"
                        :searchable="false"
                        :clearable="false"
                        v-model="newData.billing_cycle"
                        append-to-body />
                  </div>

                  <div class="form-group mb-15 with_top_block">
                    <span class="form_group_top_block" >Cycle type</span>
                    <v-select
                        :options="cycleType.selectOptions"
                        :searchable="false"
                        :clearable="false"
                        :reduce="action => action.id"
                        v-model="newData.cycle_type"
                        append-to-body />
<!--                    <SelectField-->
<!--                                 caption="Cycle type"-->
<!--                                 :reduce="t => t.id"-->
<!--                                 :searchable="false"-->
<!--                                 :clearable="false"-->
<!--                                 :value="newData.cycle_type"-->
<!--                                 v-model="newData.cycle_type"-->
<!--                                 :options="cycleType.selectOptions">-->
<!--                    </SelectField>-->
                  </div>
                </div>
                <v-switch class="margin-b-20" label="Has a trial period?" :value="newData.has_trial"
                          v-model="newData.has_trial" />
                <div class="form_group_col_3" v-if="newData.has_trial">
                  <div class="form-group mb-15 with-icon with_top_block">
                    <PriceField label="Billing amount" v-model.number="newData.trial_billing_amount"
                                :required="newData.is_subscription && newData.has_trial"
                                :currency-code="currencySymbol" />
                  </div>
                  <div class="form-group mb-15 with_top_block">
                    <span class="form_group_top_block" >Billing cycle</span>
                    <v-select
                        :options="billingCycle.selectOptions"
                        :searchable="false"
                        :clearable="false"
                        v-model="newData.trial_billing_cycle"
                        append-to-body />
                  </div>
                  <div class="form-group mb-15 with_top_block">
                    <span class="form_group_top_block" >Cycle type</span>
                    <v-select
                        :options="cycleType.selectOptions"
                        :searchable="false"
                        :clearable="false"
                        label="label"
                        :reduce="action => action.id"
                        v-model="newData.trial_cycle_type"
                        append-to-body />

                  </div>
                </div>
              </div> <!-- is subscription -->
            </div>
        </template>

        <template v-slot:actions>
          <a v-if="step==1" @click="closePopup" class="btn brdr_btn">Cancel</a>
          <a v-else @click="step=1" class="btn brdr_btn">Back</a>

          <button v-if="step==1" @click="step = 2" class="btn continue_btn"  >Continue</button>
          <v-button v-else label="Create product" @click="createProduct(newData)" :loading="isSaving" :disabled="!isValid"></v-button>
        </template>
    </Popup>

</template>

<script>
import API from "@/api"
import Popup from "@/components/base/popup";
import SelectButton from "@/components/base/select_button";
import InputField from "@/components/base/input-field";
import PriceField from "@/components/base/price-field";
import SelectField from "@/components/base/select-field";
import VSwitch from "@/components/base/v-switch";
import VButton from "@/components/base/v-button";
import {getSymbol} from "@/helpers/currencies";
import {mapGetters} from "vuex";
// import Templates from "@/views/Templates";
export default {
    name: "CreateProductPopup",
    components: {
      VButton,
      VSwitch,
      SelectField,
      PriceField,
      InputField,
      SelectButton,
        // Templates,
        Popup
    },
    mixins: [API],
    props: ['productsLength',],
    data() {
        return {
          isSaving: false,
          step: 1,
          continueBtnDisabled: true,
          isSubscription: false,
          newData: {
            "name": '',
            "price": 0,
          },
          recurringTimes: {
            selectValue: 4,
            selectOptions: [],
          },
          billingCycle: {
            selectValue: 4,
            selectOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,25, 26, 27, 28, 29, 30],
          },
          cycleType: {
            selectValue: 'day(s)',
            selectOptions: [
              {id: 1, label: "day(s)"},
              {id: 2, label: "week(s)"},
              {id: 3, label: "month(s)"},
              {id: 4, label: "year(s)"}
            ],
          },
        }
    },
  computed: {
    currencySymbol() {
      return this.getFunnelStore.currency_code;
    },
    isValid() {
      if (!this.newData.name) return false;
      return true;
    },
    ...mapGetters([
      "getFunnelStore",
    ]),
  },
  methods: {
    async createProduct(newData) {
      try {
        this.isSaving = true;
        let {id, step} = this.$route.params;

        newData.price = parseFloat(newData.price);
        newData.billing_amount = parseFloat(newData.billing_amount);

	      let nameId = newData.name.replace(/ /gi, "_").toUpperCase();
	      let obId = nameId + '-OB';
	      newData.friendly_id = nameId;
	      newData.order_bump_id = obId;
	      newData.funnel_step = parseInt(step)
	      newData.funnel_id = parseInt(id)

	      let result = await this.api.steps.createProduct(newData);
        if (!result.error) {
          this.$store.dispatch('ADD_PRODUCT', result);
        } else {
          throw result;
        }
        this.$emit('created', newData)
      } catch (e) {
        console.error("ERROR", e);
        this.$notify({
          group: 'main',
          type: 'warn',
          duration: 6000,
          title: 'Something went wrong! try again later.',
        });
      } finally {
        this.isSaving = false;
      }
    },
    priceChange(e){
        this.newData.price = parseFloat(e.target.value);
        console.log('priceChange:', this.newData.price);
    },
    closePopup() {
        this.$emit("close");
    },
    setupArrays() {
      let selectOptions = [{id:0, label:'Infinity'}];

      for (let i = 2; i <= 50; i++) {
        selectOptions.push({id:i, label:i+""});
      }
      this.recurringTimes.selectOptions = selectOptions;

      this.billingCycle.selectOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,25, 26, 27, 28, 29, 30];

    },
  },
  created(){
    var { id, step } = this.$route.params;

    var currentProduct = {
        'product_variants' : null,
        'billing_amount' : 0,
        'billing_cycle' : 1,
        'billing_recurring_times' : 0,
        'config' : "{\"highlight\":false,\"tag\":\"\",\"color\":\"silver\",\"size\":\"small\"}",
        'created_at' : null,
        'cycle_type' : 1,
        'deleted_at' : null,
        'display_price' : "",
        'funnel_id' : parseInt(id),
        'has_trial' : false,
        'is_ob' : false,
        'is_physical' : false,
        'is_subscription' : false,
        'name' : "",
        'order_index' : this.productsLength + 1,
        'price' : 0,
        'step_id' : parseInt(step),
        'trial_billing_amount' : 0,
        'trial_billing_cycle' : 1,
        'trial_cycle_type' : 1,
        'updated_at' : null,
        'user_id' : parseInt(this.$store.state.user)
    }

    this.newData = currentProduct;

    this.setupArrays();
  },
}
</script>
<style lang="scss">
.create-product-popup {
  .funnel_details_step {
    .product-name {
      margin-bottom: 20px;
    }
  }
}
</style>
